import { ClientViewingContext } from "@/shared/domain/agentThread/AgentThreadRecord";

/**
 * Adds the reader's t=0 to an outgoing viewing context, so the agent resolves
 * a bare relative time the user types ("what happened around 65 s?") against
 * the same origin their screen is using, and can name that origin back to them.
 *
 * Callers pass an anchor only while relative timestamps are on screen: a user
 * reading absolute times is typing absolute times, and a stale anchor in the
 * context would invite the agent to misread them. They also read it at send
 * time rather than earlier — a thread following the visualizer moves its t=0
 * whenever the workspace loads other files.
 *
 * The instant travels as a decimal string — `JSON.stringify` throws on a
 * bigint, and a 19-digit epoch value does not survive a round trip through a
 * JS number.
 */
export function withDisplayAnchor(
  context: ClientViewingContext,
  anchor: { ns: bigint; label: string } | undefined,
): ClientViewingContext {
  if (anchor === undefined) {
    return context;
  }
  return {
    ...context,
    display_time_anchor_ns: anchor.ns.toString(),
    display_time_anchor_label: anchor.label,
  };
}
